<template>
  <div>
    <ValidationObserver ref="form">
      <Title
        color="white"
        v-if="!titleInside"
        title="Contact Us"
        subtitle="We aim to get back to you within a few hours!"
      />
      <Card v-show="result.length === 0">
        <template v-slot:title>
          <Title
            v-if="titleInside"
            title="Contact Us"
            subtitle="We aim to get back to you within a few hours!"
            class="bg-brown f-white"
          />
        </template>
        <template v-slot:content>
          <label class="label">Name</label>
          <validation-provider rules="required" v-slot="{ errors }">
            <input type="text" placeholder="Your Name" name="Name" class="input" v-model="form.name" />
            <p class="is-danger">{{ errors[0] }}</p>
          </validation-provider>

          <validation-provider rules="required|email" v-slot="{ errors }">
            <label class="label">Email Address</label>
            <input
              type="text"
              placeholder="Your Email Address"
              class="input"
              v-model="form.email"
              name="Email"
            />
            <p class="is-danger">{{ errors[0] }}</p>
          </validation-provider>

          <validation-provider v-slot="{ errors }">
            <label class="label">Phone number</label>
            <input
              type="text"
              placeholder="Your phone number"
              class="input"
              v-model="form.phone"
              name="phone"
            />
            <p class="is-danger">{{ errors[0] }}</p>
          </validation-provider>

          <validation-provider rules="required" v-slot="{ errors }">
            <label class="label">Subject</label>
            <input
              type="text"
              placeholder="Subject"
              class="input"
              v-model="form.subject"
              name="Subject"
            />
            <p class="is-danger">{{ errors[0] }}</p>
          </validation-provider>

          <validation-provider rules="required" v-slot="{ errors }">
            <label class="label">Message</label>
            <textarea
              class="textarea"
              placeholder="Lorem ipsum dolor sit amet, consectetur adipisicing elit..."
              v-model="form.message"
              name="Message"
            ></textarea>
            <p class="is-danger">{{ errors[0] }}</p>
          </validation-provider>

          <div class="has-text-centered">
            <br />
            <a
              class="button has-text-centered is-primary-background"
              type="submit"
              @click="sent"
            >Send Message</a>
          </div>

          <br />
          <p class="privacy has-text-centered">You must be 16 or over to send us an email.</p>
        </template>
      </Card>
    </ValidationObserver>

    <div class="antispam" v-show="result.length">
      <h1 class="is-size-3">{{ result }}</h1>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Title from "./Title.vue";
import Card from "./Card.vue";

import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

extend("email", email);
extend("required", {
  ...required,
  message: "{_field_} is required"
});

export default {
  name: "ContactForm",
  components: {
    Card,
    Title,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      form: {
        message: "",
        email: "",
        phone: "",
        name: "",
        subject: ""
      },
      result: ""
    };
  },
  methods: {
    async sent() {
      try {
          const response = await axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/contact-service/send`,
            {
              id: process.env.VUE_APP_CONTACT_FORM_KSUID,
              name: this.form.name,
              email: this.form.email,
              phone: this.form.phone,
              subject: this.form.subject,
              message: this.form.message,
            },
            {
              headers: {
                "x-api-key": process.env.VUE_APP_API_KEY
              }
            }
          );
          this.reset();
        } catch (error) {
          console.error(error);
          this.reset("Error sending, please refresh the page and try again.");
        }
    },
    reset(result = "Message sent, we will get back to you within 5 days") {
      this.form = {
        message: "",
        email: "",
        name: "",
        subject: ""
      };
      this.result = result;
      this.$refs.form.reset();
    }
  },
  props: {
    titleInside: {
      type: Boolean,
      default: true,
      required: false,
    }
  }
};
</script>

<style scoped>
.antispam {
  text-align: center;
  width: 100%;
}

.border {
  margin: 1em;
  padding: 1em;
  border: 1px solid #555555;
  border-radius: 2px;
}

.button {
  background: #8f8f8f;
  border: 1px solid #8f8f8f;
  box-shadow: 0 0 1px #8f8f8f;
  color: white !important;
  font-size: 1.5em;
}

h1 {
  color: white;
}

.button:hover {
  background: #aaaaaa;
  border: 1px solid #aaaaaa;
}

.is-danger {
  color: red;
}

.label {
  font-size: 1.3rem;
  margin-bottom: 0rem;
  margin-top: 1rem;
  text-align: left;
}
</style>